export const singleParamActionCreator = type => (payload = {}) => ({ type: type.default || type, payload })
